// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.defaultSeat[data-v-04decd88] {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 50%;
  background-color: #fff;
}
.defaultSeat .error-description[data-v-04decd88] {
  min-width: 185px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  height: 34px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.5);
  max-width: 80%;
  margin-top: 10px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/defaultSeat.vue","webpack://./defaultSeat.vue"],"names":[],"mappings":"AAsBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,wBAAA;EACA,wBAAA;EACA,sBAAA;ACrBF;ADYA;EAWI,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACpBJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.defaultSeat {\n  width: 100%;\n  height: 100%;\n  display:flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: 50%;\n  background-color: #fff;\n  .error-description{\n    min-width: 185px;\n    background: #fff;\n    border: 1px solid rgba(0,0,0,.06);\n    height: 34px;\n    opacity: .8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: rgba(0,0,0,.5);\n    max-width: 80%;\n    margin-top: 10px;\n    text-align: center;\n  }\n}\n",".defaultSeat {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: 50%;\n  background-color: #fff;\n}\n.defaultSeat .error-description {\n  min-width: 185px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  height: 34px;\n  opacity: 0.8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 0, 0, 0.5);\n  max-width: 80%;\n  margin-top: 10px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
